import React, { useEffect, useMemo } from "react";

import { useTranslation } from "react-i18next";

import LoaderSpinner from "@components-shared/LoaderSpinner";
import AdminLayoutWrapper from "@components/layout/AdminLayoutWrapper";
import DepositLimitPopup from "@components/popups/desktop/deposit-limit/DepositLimitPopup";
import { ConfigType } from "@data-types/use-scroll-restoration/useScrollRestoration";
import { useRootAppStore } from "@hooks";
import { useScrollRestoration } from "@hooks/useScrollRestoration";
import { DepositContext } from "@state/context/payment/DepositContext";
import { DepositStore } from "@state/stores/payment/deposit";
import { setTabTitle } from "@utils";
import { observer } from "mobx-react";

import DepositTabs from "./DepositTabs";
import { LugasLimitExcededPopup } from "./new-deposit";

export default observer(function DepositPage() {
	const { t } = useTranslation();
	const rootStore = useRootAppStore();

	const depositStore = useMemo(() => new DepositStore(rootStore), []);

	useEffect(() => {
		const fetchData = async () => {
			setTabTitle(t("DEPOSIT.TITLE"));
			depositStore.onInitialize();
			return () => depositStore.onDispose();
		};

		fetchData();
	}, []);

	useScrollRestoration({
		type: ConfigType.Basic,
		isLoading:
			depositStore.isLoading ||
			depositStore.isLoadingProcess ||
			!depositStore.isStoreInitialized,
	});

	return (
		<AdminLayoutWrapper>
			<DepositContext.Provider value={depositStore}>
				<LoaderSpinner isLoading={depositStore.isLoading} />
				<div className="container">
					<div className="container">
						<DepositTabs />
						<LugasLimitExcededPopup store={depositStore} />
						<DepositLimitPopup />
					</div>
				</div>
			</DepositContext.Provider>
		</AdminLayoutWrapper>
	);
});
